// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4fcdc2a3","404":"50593128"}[chunkId] + ".chunk.js";
};